<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link class="btn" :to="{name: 'EXCMTeamUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <!--<button class="btn btn-danger" @click="deleteItem(item)">-->
            <!--<span v-if="!mobileView">{{ $t('buttons.delete') }}</span>-->
            <!--<i v-else class="far fa-trash-alt"></i>-->
          <!--</button>-->
          <router-link :to="{ name: 'EXCMTeamList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row v-if="item">
                <b-col cols="12">
                  <p><b>{{$t('views.excmteam.show.name')}}:</b> {{ item.name }}</p>
                </b-col>
                <b-col cols="12" v-for="(teamUserDataItem, teamUserDataIndex) in item.teamUserData" v-bind:key="'teamUserDataItem-' + teamUserDataIndex">
                  <b-row>
                    <b-col sm="12" lg="1">
                      <h5 class="text-center">#{{ teamUserDataIndex + 1 }}</h5>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <p class="mb-0 mt-1" v-bind:class="{ 'text-center': mobileView }">{{ teamUserDataItem.userData.name }} {{ teamUserDataItem.userData.surname }}</p>
                      <p class="mb-0 mt-1" v-bind:class="{ 'text-center': mobileView }">{{ teamUserDataItem.userData.contactEmail || teamUserDataItem.userData.userEmail}}</p>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <div v-bind:class="{ 'float-right': !mobileView }">
                        <b-btn class="btn btn-danger mt-2" size="sm" @click="removeTeamUserDataItem(teamUserDataItem)">
                          <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
                          <i v-else class="far fa-trash-alt"></i>
                        </b-btn>
                      </div>
                    </b-col>
                    <b-col cols="12" v-if="item.teamUserData.length > (teamUserDataIndex + 1)">
                      <hr class="mt-1 mb-1">
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-btn variant="success" @click="createTeamUserDataItem()">{{ $t('views.excmteam.show.addUserData') }}</b-btn>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <EXCMTeamUserDataCreateModal></EXCMTeamUserDataCreateModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import getId from '@/utils/getIdFromLink'
import EXCMTeamUserDataCreateModal from '../excmteamuserdata/components/EXCMTeamUserDataCreateModal'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'excmteam/del/error',
      error: 'excmteam/show/error',
      isLoading: 'excmteam/show/isLoading',
      item: 'excmteam/show/retrieved'
    }),
    mobileView () {
      return this.$store.state.mobileView
    },
    excmTeamUserDataCreated () {
      return this.$store.state.modals.excmteamuserdata.create.created
    }
  },

  watch: {
    excmTeamUserDataCreated: function (val) {
      if (val === 1) {
        this.$store.state.modals.excmteamuserdata.create.created = 0
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    }
  },

  components: {
    Loader,
    EXCMTeamUserDataCreateModal
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      delTeam: 'excmteamuserdata/del/del',
      del: 'excmteam/del/del',
      reset: 'excmteam/show/reset',
      retrieve: 'excmteam/show/retrieve'
    }),

    createTeamUserDataItem () {
      this.$store.state.modals.excmteamuserdata.create.show = 1
      this.$store.state.modals.excmteamuserdata.create.team = this.item
    },

    editTeamUserDataItem (item) {
      // this.$store.state.modals.excmteamuserdata.create.show = 1
      // this.$store.state.modals.excmteamuserdata.create.team = item
    },

    removeTeamUserDataItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.delTeam(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        }
      })
    },

    redirectAfterDelete () {
      if (this.deleteError === '') {
        this.$router.push({ name: 'EXCMTeamList' })
      } else {
        this.$store.state.excmsla.del.error = ''
      }
    },

    archiveItem (item) {
      this.$http
        .put('api/e_x_c_m_teams/' + this.getIdLink(this.item['@id']), {
          state: 0
        })
        .then(response => {
          this.$router.push({ name: 'EXCMTeamList' })
          this.$Swal({ // show notification with success
            type: 'success',
            title: this.$t('notifications.update.updatedTitle'),
            showConfirmButton: false,
            timer: 2500
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item).then(() => this.redirectAfterDelete())
        }
      })
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
